import { css } from '@emotion/css';
import React from 'react';
import { UserColor } from 'src/models/resort/UserColor';

interface ResortRibbonProps {
  color: UserColor;
}

export const ResortRibbon: React.FC<ResortRibbonProps> = ({ color, children }) => {
  const encodedMainColor = encodeURIComponent(color.main);
  const encodedRibbonColor = encodeURIComponent(color.ribbon);
  const ribbonSideImage = `data:image/svg+xml,%3Csvg width="20" height="38" viewBox="0 0 20 38" preserveAspectRatio="none" fill="${encodedRibbonColor}" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M3.672 0C1.025 0-.761 2.175.322 4.117L8.555 19 .322 33.883C-.746 35.818 1.025 38 3.672 38H20V0H3.672z" fill="${encodedMainColor}"/%3E%3Cpath d="M13.267 31.735l4.117 4.307.616-.254v-8.336l-.685-.253-4.038 4.141-.01.395zM13.267 19.069l4.117 4.307.616-.256v-8.333l-.685-.254-4.038 4.142-.01.394zM13.267 6.4l4.117 4.307.616-.253V2.118l-.685-.254-4.038 4.142-.01.394z"/%3E%3Cpath d="M11.509 0h3.403V.836l-4.836 5.398v.254l4.836 5.458v1.555L10.076 18.9v.256l4.836 5.459v1.555l-4.836 5.395v.257l4.836 5.459V38H11.51v-.128l-5.208-5.875v-.588l5.208-5.88v-.326l-3.932-4.435L8.555 19l-.954-1.725 3.908-4.412v-.326L6.301 6.663v-.588L11.509.197V0z"/%3E%3C/svg%3E`;
  return (
    <div
      className={css`
      display: inline-block;
      text-align: center;
      color: ${color.text};
      min-width: 200px;
      max-width: 95%;
      min-height: 44px;
      background: ${color.main};
      position: relative;
      padding: 10px 5px;

      &::before {
        left: -19px;
      }
      &::after {
        right: -19px;
        transform: scaleX(-1);
      }
      &::before,
      &::after {
        content: '';
        position: absolute;
        width: 20px;
        top: 0;
        bottom: 0;
        background: url('${ribbonSideImage}');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    `}
    >
      {children}
    </div>
  );
};
